<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		@click:outside="closeDialog()"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card dense flat>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">{{ dialogTitle }}</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="closeDialog()" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<div class="ma-5" v-html="formattedDialogContent"></div>
			<v-card-actions>
				<v-row no-gutters justify="center">
					<v-btn
						v-if="draftFlag"
						class="mt-4 mr-4"
						color="secondary"
						dark
						@click="createOrderDataDraft()"
						>保存する</v-btn
					>
					<v-btn
						v-if="createFlag"
						class="mt-4 mr-4"
						color="secondary"
						dark
						@click="createOrderData()"
						>作成する</v-btn
					>
					<v-btn v-if="deleteFlag" class="mt-4 mr-4" color="red" dark @click="deleteDraft()"
						>削除する</v-btn
					>
					<v-btn v-if="fileDeleteFlag" class="mt-4 mr-4" color="red" dark @click="deleteFile()"
						>削除する</v-btn
					>
					<v-btn class="mt-4 ml-4" @click="closeDialog()">キャンセル</v-btn>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		dialogTitle: {
			type: String,
			default: "",
		},
		dialogContent: {
			type: String,
			default: "",
		},

		createFlag: {
			type: Boolean,
			default: false,
		},
		onlyDataFlag: {
			type: Boolean,
			default: false,
		},
		draftFlag: {
			type: Boolean,
			default: false,
		},
		deleteFlag: {
			type: Boolean,
			default: false,
		},
		fileDeleteFlag: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {}
	},
	methods: {
		closeDialog() {
			this.showDialog = false
			this.$emit("resetBtnFlag")
		},
		createOrderDataDraft() {
			this.$emit("createOrderDataDraft")
		},
		createOrderData() {
			this.$emit("createOrderData")
		},
		deleteDraft() {
			this.$emit("deleteDraft")
		},
		deleteFile() {
			this.$emit("deleteFile")
			this.closeDialog()
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
		formattedDialogContent() {
			return this.dialogContent.replace(/\n/g, "<br>")
		},
	},
}
</script>
